import { gql } from "@apollo/client";

export const switchApbNextGql = gql`
    mutation switchAPBNext($contractId: String!, $parkingId: String!) {
        switchAPBNext(contractId: $contractId, parkingId: $parkingId) {
            apbNext
        }
    }
`